import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import axiosInstance from '../common/axios'; // your axios wrapper
import commissionService from '../service/productCommissionService'; 
import { fetchSuppliers } from '../service/supplierService';
import { fetchSupplierProducts} from '../service/filterService';
import {getCurrencies} from '../service/commonService';
import PriceAndProfitCalculator from './PriceAndProfitCalculator';
export default function ProductCommissionManager() {
  const [commissions, setCommissions] = useState([]);
  const [open, setOpen] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [editId, setEditId] = useState(null);
  
    const [commissionRate, setCommissionRate] = useState([]);
   const [commissionAmount, setCommissionAmount] = useState([]);
  
  
      const [discountRate, setDiscountRate] = useState([0]);
   const [discountAmount, setDiscountAmount] = useState([0]);
   const [discountTotalAmount, setDiscountTotalAmount] = useState([0]);
  
        const [couponRate, setCouponRate] = useState([0]);
   const [couponAmount, setCouponAmount] = useState([0]);
     const [couponTotalAmount, setCouponTotalAmount] = useState([0]);


  
  

  

  const [form, setForm] = useState({
    productId: "",
    supplierId: "",
    commissionPercent: "",
    fixedCommissionAmount: "",
    regionCode: "",
    currencyId: "",
    salesCost: "",
    salesPrice: "",
  });

  const [products, setProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  // ✅ Fetch data
  useEffect(() => {
    fetchCommissions();
    fetchDropdownData();
  }, []);

  const fetchCommissions = async () => {
    const res = await commissionService.fetchProductCommission(); // axiosInstance.get("/product-commissions");
    setCommissions(res);
  };

  const fetchDropdownData = async () => {
    const [suppliersRes, currenciesRes] = await Promise.all([
      fetchSuppliers(),
     getCurrencies(),
    ]);
    
    setSuppliers(suppliersRes.data);
    setCurrencies(currenciesRes.data.content);
  };
  
  const getProductData = async(supplierId) => {
    fetchSupplierProducts(supplierId, {active: true, approval: false}).then(res => setProducts(res.data));
  };
  
  const handleOpen = (commission = null, mode = "edit") => {
    
    if (commission) {
        getProductData(commission.supplierId);
      
      const product = products.find((f) => f.productId === commission.productId);
      if (product) {
           setForm((prev) => ({ ...prev, salesCost: product.basePrice }));
           setDiscountAmount(product.sharedDiscount?.amount);
           setDiscountRate(product.sharedDiscount?.percentage);
           if(product.couponDiscount?.discountType === "PERCENTAGE"){
                    setCouponRate(product.couponDiscount?.discountValue);
                  }else{
                     setCouponAmount(product.couponDiscount?.discountValue);
                  }
            }
      
      setForm(commission);
      setEditId(commission.id);
      setViewMode(mode === "view");
    } else {
      setForm({
        productId: "",
        supplierId: "",
        commissionPercent: "",
        fixedCommissionAmount: "",
        regionCode: "",
        currencyId: "",
        salesCost: "",
        salesPrice: "",
      });
      setEditId(null);
      setViewMode(false);
      setCommissionRate(null);
      setCommissionAmount(null);
      
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setViewMode(false);
  };

  const handleChange = (e) => {
        const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    
      if (name === "supplierId") {
    setForm((prev) => ({ ...prev, productId: "" })); // reset product
    if (value) {
      getProductData(value);
    } else {
      setProducts([]); // clear if no supplier selected
    }
  }
    
            if (name === "productId") {
              
               if (value) {
                const product = products.find((f) => f.productId === value);
                if (product) {
                  setForm((prev) => ({ ...prev, salesCost: product.basePrice }));
                  setDiscountAmount(product.sharedDiscount?.amount);
                  setDiscountRate(product.sharedDiscount?.percentage);
                  if(product.couponDiscount?.discountType === "PERCENTAGE"){
                    setCouponRate(product.couponDiscount?.discountValue);
                  }else{
                     setCouponAmount(product.couponDiscount?.discountValue);
                  }
                 
                }
              } else {
                // Clear salesCost if the productId is empty
                setForm((prev) => ({ ...prev, salesCost: "" }));
                
                setCouponAmount(0);
                setCouponRate(0);
                setDiscountAmount(0);
                setDiscountRate(0);
              }
            }
    
                if (name === "fixedCommissionAmount") {
               if (value) {
                const fixedAmtNum  = Number(value ?? 0);
                const salesCostNum = Number(form.salesCost ?? 0);
                 
                 
                   if (!Number.isFinite(fixedAmtNum) || !Number.isFinite(salesCostNum)) {
                      // optional: show validation error here
                      return;
                  }
                 
                  const fixedCommissionPrice = salesCostNum + fixedAmtNum;
                 
                 //const calculatedDiscountValue = Number(0);
                
                 
                 const salesPrice = Math.round((fixedCommissionPrice + Number.EPSILON) * 100) / 100;
                 
                  setCommissionRate(null); 
                  setCommissionAmount(fixedAmtNum);
                  
                  setForm((prev) => ({ ...prev, salesPrice: salesPrice }));
                }
              }
            
    
                    if (name === "commissionPercent") {
               if (value) {
                const salesCost =   form.salesCost;
                if (salesCost) {
                
                    const calculatedValue = (salesCost * value) / 100;
                    const formattedAmount = Number(calculatedValue.toFixed(2));
                  
                  setCommissionRate(value);
                  setCommissionAmount(formattedAmount);
                  setForm((prev) => ({ ...prev, salesPrice: salesCost+formattedAmount }));
                }
              }
                    }
  };

  const handleSave = async () => {
    
  
    
     if (
    !form.productId ||
    !form.supplierId ||
    !form.regionCode ||
    !form.currencyId ||
    (!form.commissionPercent && !form.fixedCommissionAmount)
  ) {
    alert("Please fill in all required fields.");
    return;
  }
    
    
    if (editId) {
      await commissionService.updateProductCommission(editId,form); //axiosInstance.put(`/product-commissions/${editId}`, form);
    } else {
      await commissionService.saveProductCommission(form); // axiosInstance.post("/product-commissions", form);
    }
    fetchCommissions();
    handleClose();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      await  commissionService.deleteProductCommission(id); // axiosInstance.delete(`/product-commissions/${id}`);
      fetchCommissions();
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "productName", headerName: "Product", flex: 1 },
    { field: "supplierName", headerName: "Supplier", flex: 1 },
    { field: "commissionPercent", headerName: "Commission %", flex: 1 },
    { field: "fixedCommissionAmount", headerName: "Fixed Amount", flex: 1 },
    { field: "regionCode", headerName: "Region", flex: 1 },
    { field: "currencyId", headerName: "Currency", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleOpen(params.row, "edit")}>
            <Edit />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row.id)}>
            <Delete />
          </IconButton>
          <IconButton onClick={() => handleOpen(params.row, "view")}>
            <Visibility />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Button variant="contained" onClick={() => handleOpen()}>
        Add Product Commission
      </Button>

      <div style={{ height: 500, marginTop: 20 }}>
        <DataGrid rows={commissions} columns={columns} getRowId={(r) => r.id} />
      </div>

      {/* Dialog for Add/Edit/View */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          {viewMode ? "View Product Commission" : editId ? "Edit" : "Add"} Product Commission
        </DialogTitle>
        <DialogContent dividers>
          
             {/* Supplier Dropdown */}
          <TextField
            select
            margin="dense"
            fullWidth
            name="supplierId"
            label="Supplier"
            value={form.supplierId}
            onChange={handleChange}
            disabled={viewMode}
            required
          >
            {suppliers && suppliers.map((s) => (
              <MenuItem key={s.supplierId} value={s.supplierId}>
                {s.supplierName}
              </MenuItem>
            ))}
          </TextField>

          {/* Product Dropdown */}
          <TextField
            select
            margin="dense"
            fullWidth
            name="productId"
            label="Product"
            value={form.productId}
            onChange={handleChange}
            disabled={viewMode}
            required
          >
            {products && products.map((p) => (
              <MenuItem key={p.productId} value={p.productId}>
                {p.productName}
              </MenuItem>
            ))}
          </TextField>

       

          {/* Commission % */}
          <TextField
            margin="dense"
            fullWidth
            name="commissionPercent"
            label="Commission Percent"
            type="number"
            value={form.commissionPercent}
            onChange={handleChange}
            disabled={viewMode}
          />

          {/* Fixed Commission Amount */}
          <TextField
            margin="dense"
            fullWidth
            name="fixedCommissionAmount"
            label="Fixed Commission Amount"
            type="number"
            value={form.fixedCommissionAmount}
            onChange={handleChange}
            disabled={viewMode}
          />

          {/* Region Code */}
          <TextField
            margin="dense"
            fullWidth
            name="regionCode"
            label="Region Code"
            value={form.regionCode}
            onChange={handleChange}
            disabled={viewMode}
            required
          />

          {/* Currency Dropdown */}
          <TextField
            select
            margin="dense"
            fullWidth
            name="currencyId"
            label="Currency"
            value={form.currencyId}
            onChange={handleChange}
            disabled={viewMode}
            required
          >
            {currencies && currencies.map((c) => (
              <MenuItem key={c.currencyId} value={c.currencyId}>
                {c.code}
              </MenuItem>
            ))}
          </TextField>

   {/* calculate Cost Code */}

                <TextField
            margin="dense"
            fullWidth
            name="Sales Price"
            label="Sales Price"
            value={form.salesPrice}
            onChange={handleChange}
            disabled={viewMode}
          />
              <>
              <PriceAndProfitCalculator salesCost={form.salesCost} commissionFixed={form.fixedCommissionAmount} commissionPercentage={form.commissionPercent} discountFixed={discountAmount} discountPercentage={discountRate} couponAmount={couponAmount} couponPercentage={couponRate} />
              </>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          {!viewMode && (
            <Button variant="contained" onClick={handleSave}>
              Apply Commission
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
